// PWA install helpers — captures the native beforeinstallprompt event early
// and exposes standalone/device detection for the InstallPrompt UI.
let deferredPrompt = null;

export function initInstallCapture() {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new Event("pstr-install-available"));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    localStorage.setItem("pstr_pwa_installed", "1");
    window.dispatchEvent(new Event("pstr-install-done"));
  });
}

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true ||
  localStorage.getItem("pstr_pwa_installed") === "1";

export const isMobileDevice = () =>
  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const isIOS = () =>
  /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const hasNativePrompt = () => deferredPrompt !== null;

export async function promptInstall() {
  if (!deferredPrompt) return null;
  const evt = deferredPrompt;
  deferredPrompt = null;
  evt.prompt();
  const choice = await evt.userChoice;
  if (choice.outcome !== "accepted") deferredPrompt = evt;
  return choice.outcome;
}
